// # configure scroll magic and gsap
import ScrollMagic from 'scrollmagic'
import { TweenMax } from 'gsap'
import scrollController from './ScrollController'
import { parseProps, getWebflowProps, getParallaxProps } from './../lib/dataTweenParser'
import { getScrollMagicSceneProps } from './../lib/dataScrollMagicParser'

const DATA_ATTR_WEBFLOW = "webflow"
const DATA_ATTR_SETUP = "webset"
const DATA_ATTR_PARALLAX = "webpara"

class ShowUp {
  /**
  * @constructor
  **/
  constructor() {
    this.scenes = []
  }
  /**
   * Init all scenes
   */
  init() {
    this.buildWebflowScenes()
    this.buildParallaxScenes()
    this.addEventListeners()
  }
  /**
   * Add event listeners
   */
  addEventListeners() {
    $(document).on('DOMContentLoaded load', $.proxy(this.onWindowUpdate, this))
    $(window).on('resize', $.proxy(this.onWindowUpdate, this))
  }
  /**
   * Remove event listeners
   */
  removeEventListeners() {
    $(document).off('DOMContentLoaded load', $.proxy(this.onWindowUpdate, this));
    $(window).off('resize', $.proxy(this.onWindowUpdate, this));
  }
  onWindowUpdate(e) {
    if (this.scenes.length > 0) {
      scrollController.refresh()
    }
  }
  /**
   * Bild scenes for data-webflow elements
   */
  buildWebflowScenes() {
    const list = [...document.querySelectorAll('*[data-' + DATA_ATTR_WEBFLOW + ']')]
    list.forEach(this.buildWebflowScene.bind(this))
  }
  /**
   * Build scene
   * @param {DOM} el 
   * @param {Int} index 
   */
  buildWebflowScene(el, index) {
    const wfp = getWebflowProps(el.dataset[DATA_ATTR_WEBFLOW])
    const setup = parseProps(el.dataset[DATA_ATTR_SETUP])
    if (wfp.show) {
      const smsp = getScrollMagicSceneProps(el, setup)
      const scene = new ScrollMagic.Scene(smsp)
      scene.setTween(TweenMax.from(el, wfp.show.time, wfp.show.tween))
      scene.addTo(scrollController.get())
      this.scenes.push(scene)
    }
  }
  /**
   * Build Parallax scenes
   */
  buildParallaxScenes() {
    const list = [...document.querySelectorAll('*[data-' + DATA_ATTR_PARALLAX + ']')]
    list.forEach(this.buildParallaxScene.bind(this))
  }
  buildParallaxScene(el, index) {
    const pp = getParallaxProps(el.dataset[DATA_ATTR_PARALLAX])
    const setup = parseProps(el.dataset[DATA_ATTR_SETUP])
    if (pp) {
      const smsp = getScrollMagicSceneProps(el, setup)
      const scene = new ScrollMagic.Scene(smsp)
      scene.setTween(TweenMax.to(el, 1, pp.parallax.tween))
      scene.addTo(scrollController.get())
      this.scenes.push(scene)
    }
  }
  /**
   * Hide webflow elements
   */
  hide() {
    const list = [...document.querySelectorAll('*[data-' + DATA_ATTR_WEBFLOW + ']')]
    list.forEach(this.hideWebflowElement.bind(this))
  }
  /**
   * Hide element
   * @param {DOM} el 
   * @param {Int} index 
   */
  hideWebflowElement(el, index) {
    const wfp = getWebflowProps(el.dataset[DATA_ATTR_WEBFLOW])
    if (wfp.hide) {
      TweenMax.to(el, wfp.hide.time, wfp.hide.tween)
    }
  }
  /**
   * Destroy all scenes
   */
  destroy() {
    this.removeEventListeners()
    this.scenes.forEach((scene) => {
      scene.destroy()
      scene = null
    })
    this.scenes = []
  }
  /**
   * Rebuild / refresh
   */
  rebuild() {
    this.destroy()
    this.init()
  }
  
}
const showUp = new ShowUp();
export default showUp;